export default __webpack_public_path__ + "static/media/circle-user_.731617d5.svg";